import { render } from "./ResponsePage.vue?vue&type=template&id=1adea629&scoped=true"
import script from "./ResponsePage.vue?vue&type=script&lang=js"
export * from "./ResponsePage.vue?vue&type=script&lang=js"

import "./ResponsePage.vue?vue&type=style&index=0&id=1adea629&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adea629"]])

export default __exports__